import apiClient from './client';

export interface Verse {
  reference: string;
  text: string;
  version: string;
}

export interface BiblePassage {
  passageHtml: string;
  audioUrl: string;
  book: string;
  chapter: string;
  chapterId: number;
}

export interface BibleChapter {
  id: number;
  book: string;
  chapter: number;
  verse_count: number;
  testament: string;
  content: string;
  has_read: boolean;
  last_read_date: string;
}

export interface BibleProgress {
  chaptersRead: number;
  totalChapters: number;
  percentageCompleted: number;
  recentlyRead: {
    id: number;
    book: string;
    chapter: number;
    last_read_date: string;
  }[];
  readByTestament: {
    Old: {
      read: number;
      total: number;
    };
    New: {
      read: number;
      total: number;
    };
  };
}

export const verseService = {
  getAllBooks: () => 
    apiClient.get<{books: {name: string, abbreviation: string, testament: string, chapters: number}[]}>('bible/books'),
  
  getBookByName: (book: string) => 
    apiClient.get<{book: {name: string, abbreviation: string, testament: string, chapters: number}}>(`bible/book/${book}`),
  
  getPassage: (book: string, chapter: string) => 
    apiClient.get<BiblePassage>(`bible/passage/${book}/${chapter}`),
  
  getChapterById: (id: string) => 
    apiClient.get<{success: boolean, data: BibleChapter}>(`bible/chapters/${id}`),
  
  getReadingProgress: () => 
    apiClient.get<{success: boolean, data: BibleProgress}>('bible/progress'),
  
  markChapterAsRead: (chapterId: number) => 
    apiClient.post<{success: boolean, data: {chapter_id: number, read_date: string, is_first_time: boolean}}>(`bible/chapters/${chapterId}/mark-as-read`, {}),
  
  // Alias for getPassage with a default book/chapter for "verse of the day"
  getVerseOfTheDay: () => 
    apiClient.get<BiblePassage>('bible/passage/Psalms/23'),
}; 